import React from 'react'
import {useDispatch, useSelector} from "react-redux"
import {Navigate, useLocation} from "react-router-dom"
import {login} from "../../reducers/authReducer"
import api from "../../lib/axios";

const ProtectedRoute = ({children}) => {
  let location = useLocation();
  const dispatch = useDispatch();
  const token = localStorage.getItem("accessToken");

  const user = useSelector((state) => state.auth.user);

  if (user) {
    return children;
  }

  if (!token) {
    return <Navigate to="/Login" state={{ from: location}} replace />
  }
  else {
    api.get("/User/user-data").then((res) => {
      dispatch(login(res.data.data));
      return children;
    }).catch(() => {
      return <Navigate to="/Login" state={{ from: location}} replace />
    });
  }
};

export default ProtectedRoute; 